<template>
  <div class="relative flex flex-col justify-center items-center shadow-lg w-6/12 rounded-2xl bg-white py-8">
    <span @click="close" class="absolute left-8 top-4 text-customGray text-sm cursor-pointer">Close</span>
    <WarningIcon class="mb-1"/>
    <h2 class="text-center text-lg font-semibold mb-2 text-yank">Hey there!</h2>
    <span class="mb-4 font-light text-center w-4/6 text-yank">{{alertText}}</span>
    <button @click="close" class="bg-payneHot rounded-lg text-white text-xs py-3 px-14">Return to post</button>
</div>
</template>

<script>
import WarningIcon from '@/components/svg/WarningIcon.vue';

export default {
    name:"AlertModal",

    components:{
        WarningIcon
    },

    props: {
        alertText: {
            type: String,
            required:true 
        },
    },
    
    methods: {
        close() {
            this.$emit('close')
        },
    },
}
</script>